@use "@fukuri-admins/ui/layout" as *;

.container {
  display: grid;
  min-height: 400px;
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
}